import React,{useEffect, useState, useContext} from 'react';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from 'CustomHooks/useFetch';

export default function usePostcodeToLat (props) {
    const globalContext = useContext(GlobalContext);
    const [getLatLongResponse, getLatLong] = useFetch();
    
    
    const getLatAndLong = (postcode, countryCode) => {
        getLatLong(
            {
                url: `/admin/postcode/${countryCode}/${postcode}`,
                method: 'GET',
                addTokenHeader: true,
            }
        )
    }

    return [getLatAndLong,getLatLongResponse];
}
